import {
  Box,
  Button,
  Field,
  Heading,
  Input,
  Link,
  Spinner,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { useLoginPassword } from "../../../hooks/useLoginPassword";
import {
  Link as ReactRouterLink,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import { useSession } from "../../../hooks/useSession";

const schema = yup
  .object({
    email: yup.string().email().required(),
    password: yup.string().required(),
  })
  .required();

export default function LoginPage() {
  const sessionQuery = useSession({
    redirectWhenAuthorized: true,
    redirectWhenUnauthorized: false,
  });
  const [, setEmail] = useOutletContext<[string, (arg: string) => void]>();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors: formStateErrors },
  } = useForm({
    mode: "onSubmit",
    resolver: yupResolver(schema),
  });

  const mutation = useLoginPassword();

  useEffect(() => {
    if (mutation.status == "success") {
      navigate("/invoices/");
    }
  }, [navigate, mutation.status]);

  const onSubmit = async (data: { email: string; password: string }) => {
    setEmail(data.email);
    return await mutation.mutate(data);
  };

  const isDev = process.env.NODE_ENV === "development";

  return (
    <Stack textAlign="center" p={10}>
      <Heading as="h1" mb={4}>
        Logg inn
      </Heading>
      {sessionQuery.isLoading && (
        <Box>
          <Spinner />
        </Box>
      )}
      {!sessionQuery.isLoading && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <Field.Root invalid={Boolean(formStateErrors["email"])}>
            <Field.Label>E-post</Field.Label>
            <Input {...register("email")} placeholder="accounting@faktur.no" />
          </Field.Root>
          <Field.Root invalid={Boolean(formStateErrors["password"])} mt={4}>
            <Field.Label>Passord</Field.Label>
            <Input {...register("password")} type="password" />
          </Field.Root>
          <Box mt={10} minW={350}>
            {mutation.isPending && <Spinner />}
            {!mutation.isPending && <Button type="submit">Logg inn</Button>}
          </Box>
        </form>
      )}
      {isDev && (
        <Link asChild>
          <ReactRouterLink to="/auth/signup/">
            <Text>Ikke registrert?</Text>
          </ReactRouterLink>
        </Link>
      )}
    </Stack>
  );
}
